import { jsx as t } from "react/jsx-runtime";
import { d as l, aq as s, ar as d } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as p } from "react";
import { layer as c } from "../../theme/layer.js";
import { stupidInvertClasses as n } from "../../utils/index.js";
import { ChildFilter as m } from "../../utils/ChildFilter/index.js";
import '../../assets/index13.css';const f = "_tooltip_xd40h_1", x = {
  tooltip: f
}, v = p(
  ({ placement: o = "top", __inverted: i, children: r }, a) => {
    const e = l(x.tooltip, i ? n() : void 0);
    return /* @__PURE__ */ t(
      s,
      {
        ref: a,
        placement: o,
        className: e,
        style: { zIndex: c("tooltip") },
        "data-component": "Tooltip",
        children: /* @__PURE__ */ t(m, { invalidChildren: ["a", "button", "iconbutton", "link"], children: r })
      }
    );
  }
), C = (o) => d({ ...o, closeDelay: 0, delay: o.delay === "immediate" ? 0 : 300 });
export {
  v as Tooltip,
  C as TooltipTrigger
};
